import * as classnames from "classnames";

import { Icon, Msg, Select } from "@shared/components";
import { useFrontendTemplateList } from "@shared/hooks/query";
import { ApplicantChallengeModel } from "@shared/models";
import { getFrontendChallengeOptions } from "@shared/services/challenge";

export type ProgrammingLanguagePanelPropsNew = {
  challenge: ApplicantChallengeModel;
  value?: string;
  onChange: (frontendTemplate: string) => void;
};

export const FrontendChallengePanel = ({
  value,
  challenge,
  onChange,
}: ProgrammingLanguagePanelPropsNew) => {
  const { data: frontendTemplates } = useFrontendTemplateList();

  const options = getFrontendChallengeOptions({
    frontendTemplates,
    allowedTemplateSeriesCodes:
      challenge.frontendStyleConfig?.allowedTemplateSeriesCodes,
  });

  const rootStyle = classnames("code-programming-language-panel-new");

  return (
    <div className={rootStyle}>
      <div>
        <div className="code-c-walk-through__item__subtitle">
          <Msg id="start-challenge-walkthrough.setup.frontendTemplate.title" />
        </div>
        <Msg
          id="start-challenge-walkthrough.setup.frontendTemplate.choose"
          values={{
            cog: <Icon type="cog" />,
          }}
        />
      </div>
      <Select
        name="frontendTemplate"
        options={options}
        value={value}
        onChange={(e) => {
          onChange(e.currentTarget.value);
        }}
      />
    </div>
  );
};
